import axios from "axios";
import { getToken } from "./api";

const axiosClient = axios.create();

axiosClient.defaults.baseURL = "https://api.getactyvphysio.com/";
// axiosClient.defaults.baseURL = "https://a265-14-143-127-50.ngrok-free.app/";

axiosClient.defaults.headers = {
  Accept: "*/*",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers": "*",
};

const noTokenRequest = [
  "/sendEmailOTP",
  "/verifyEmailOTP",
  "/userRegistration",
  "/getEmailExists",
  "/userLogin",
  "/getStartedExercise",
  "/reachUs",
  "/callMe",
  "/razorpay/sub/monthly",
  "/razorpay/sub/quarterly",
];

axiosClient.interceptors.request.use(async function (config) {
  if (noTokenRequest.includes(config.url)) {
    return config;
  }
  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

//All request will wait 10 seconds before timeout
axiosClient.defaults.timeout = 10000;

export async function getRequest(URL, payload = {}) {
  return await axiosClient
    .get(`/${URL}`, { data: payload, timeout: 5000 })
    .then((response) => response);
}

export async function postRequest(URL, payload) {
  return await axiosClient
    .post(`/${URL}`, payload)
    .then((response) => response);
}

export function patchRequest(URL, payload) {
  return axiosClient.patch(`/${URL}`, payload).then((response) => response);
}

export function putRequest(URL, payload) {
  return axiosClient.put(`/${URL}`, payload).then((response) => response);
}

export function deleteRequest(URL) {
  return axiosClient.delete(`/${URL}`).then((response) => response);
}
